import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "notif-header" }
const _hoisted_2 = {
  key: 1,
  class: "notif-select-all",
  title: "Selecionar todas as carregadas"
}
const _hoisted_3 = ["checked"]
const _hoisted_4 = {
  key: 2,
  class: "notif-bulk"
}
const _hoisted_5 = { class: "notif-bulk-count" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = ["disabled"]
const _hoisted_8 = { class: "notif-filters" }
const _hoisted_9 = ["value"]
const _hoisted_10 = {
  key: 0,
  class: "notif-skeleton-wrap"
}
const _hoisted_11 = {
  key: 1,
  class: "notif-empty"
}
const _hoisted_12 = ["checked", "onChange"]
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "notif-item-title" }
const _hoisted_15 = {
  key: 0,
  class: "notif-pill"
}
const _hoisted_16 = { class: "notif-item-text" }
const _hoisted_17 = { class: "notif-item-meta" }
const _hoisted_18 = { class: "notif-item-type" }
const _hoisted_19 = {
  key: 0,
  class: "notif-item-when"
}
const _hoisted_20 = {
  key: 0,
  class: "notif-loading-more"
}
const _hoisted_21 = {
  key: 1,
  class: "notif-end"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SkeletonRow = _resolveComponent("SkeletonRow")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["notif-shell", { 'notif-shell--embedded': _ctx.embedded }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (!_ctx.embedded)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "notif-back",
            type: "button",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.router.back()))
          }, [...(_cache[17] || (_cache[17] = [
            _createElementVNode("svg", {
              width: "14",
              height: "14",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "2.5",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, [
              _createElementVNode("polyline", { points: "15 18 9 12 15 6" })
            ], -1),
            _createTextVNode(" Voltar ", -1)
          ]))]))
        : _createCommentVNode("", true),
      _cache[19] || (_cache[19] = _createElementVNode("h1", { class: "notif-title" }, [
        _createElementVNode("svg", {
          width: "18",
          height: "18",
          viewBox: "0 0 24 24",
          fill: "none",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, [
          _createElementVNode("path", { d: "M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" }),
          _createElementVNode("path", { d: "M13.73 21a2 2 0 0 1-3.46 0" })
        ]),
        _createTextVNode(" Notificações ")
      ], -1)),
      (_ctx.items.length > 0)
        ? (_openBlock(), _createElementBlock("label", _hoisted_2, [
            _createElementVNode("input", {
              ref: "selectAllEl",
              type: "checkbox",
              class: "notif-cb",
              checked: _ctx.isAllSelected,
              onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleSelectAll && _ctx.toggleSelectAll(...args)))
            }, null, 40, _hoisted_3),
            _cache[18] || (_cache[18] = _createTextVNode(" Selecionar todos ", -1))
          ]))
        : _createCommentVNode("", true),
      (_ctx.selectedIds.size > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.selectedIds.size) + " selecionada" + _toDisplayString(_ctx.selectedIds.size !== 1 ? 's' : ''), 1),
            _createElementVNode("button", {
              class: "notif-bulk-btn notif-bulk-read",
              type: "button",
              disabled: _ctx.acting,
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.markSelectedRead && _ctx.markSelectedRead(...args)))
            }, " Marcar como lida ", 8, _hoisted_6),
            _createElementVNode("button", {
              class: "notif-bulk-btn notif-bulk-del",
              type: "button",
              disabled: _ctx.acting,
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.deleteSelected && _ctx.deleteSelected(...args)))
            }, " Excluir ", 8, _hoisted_7)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_8, [
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.search) = $event)),
        type: "text",
        class: "notif-input",
        placeholder: "Buscar por título ou mensagem...",
        onInput: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onFilterChange && _ctx.onFilterChange(...args)))
      }, null, 544), [
        [_vModelText, _ctx.search]
      ]),
      _withDirectives(_createElementVNode("select", {
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.statusFilter) = $event)),
        class: "notif-select",
        onChange: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.onFilterChange && _ctx.onFilterChange(...args)))
      }, [...(_cache[20] || (_cache[20] = [
        _createElementVNode("option", { value: "all" }, "Todas", -1),
        _createElementVNode("option", { value: "unread" }, "Não lidas", -1),
        _createElementVNode("option", { value: "read" }, "Lidas", -1)
      ]))], 544), [
        [_vModelSelect, _ctx.statusFilter]
      ]),
      _withDirectives(_createElementVNode("select", {
        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.typeFilter) = $event)),
        class: "notif-select",
        onChange: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.onFilterChange && _ctx.onFilterChange(...args)))
      }, [
        _cache[21] || (_cache[21] = _createElementVNode("option", { value: "all" }, "Todos os tipos", -1)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.types, (t) => {
          return (_openBlock(), _createElementBlock("option", {
            key: t,
            value: t
          }, _toDisplayString(_ctx.typeLabel(t)), 9, _hoisted_9))
        }), 128))
      ], 544), [
        [_vModelSelect, _ctx.typeFilter]
      ]),
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.dateFrom) = $event)),
        type: "date",
        class: "notif-input notif-input--date",
        onChange: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.onFilterChange && _ctx.onFilterChange(...args)))
      }, null, 544), [
        [_vModelText, _ctx.dateFrom]
      ]),
      _cache[22] || (_cache[22] = _createElementVNode("span", { class: "notif-date-sep" }, "até", -1)),
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.dateTo) = $event)),
        type: "date",
        class: "notif-input notif-input--date",
        onChange: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.onFilterChange && _ctx.onFilterChange(...args)))
      }, null, 544), [
        [_vModelText, _ctx.dateTo]
      ]),
      (_ctx.hasActiveFilters)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "notif-clear-filters",
            type: "button",
            onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.clearFilters && _ctx.clearFilters(...args)))
          }, " Limpar filtros "))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", {
      class: "notif-list",
      ref: "listEl",
      onScroll: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.onScroll && _ctx.onScroll(...args)))
    }, [
      (_ctx.loading && _ctx.items.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(6, (i) => {
              return _createVNode(_component_SkeletonRow, {
                key: i,
                columns: [70, 90, 30]
              })
            }), 64))
          ]))
        : (_ctx.items.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _cache[23] || (_cache[23] = _createElementVNode("svg", {
                width: "44",
                height: "44",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "1.2",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              }, [
                _createElementVNode("path", { d: "M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" }),
                _createElementVNode("path", { d: "M13.73 21a2 2 0 0 1-3.46 0" })
              ], -1)),
              _createElementVNode("p", null, "Nenhuma notificação encontrada" + _toDisplayString(_ctx.hasActiveFilters ? ' com esses filtros' : '') + ".", 1)
            ]))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: item.id,
                  class: _normalizeClass(["notif-item", { 'notif-item--sel': _ctx.selectedIds.has(item.id) }])
                }, [
                  _createElementVNode("label", {
                    class: "notif-cb-label",
                    onClick: _cache[15] || (_cache[15] = _withModifiers(() => {}, ["stop"]))
                  }, [
                    _createElementVNode("input", {
                      type: "checkbox",
                      class: "notif-cb",
                      checked: _ctx.selectedIds.has(item.id),
                      onChange: ($event: any) => (_ctx.toggleSelect(item.id))
                    }, null, 40, _hoisted_12)
                  ]),
                  _createElementVNode("button", {
                    class: "notif-item-body",
                    type: "button",
                    onClick: ($event: any) => (_ctx.openItem(item))
                  }, [
                    _createElementVNode("div", _hoisted_14, [
                      _createTextVNode(_toDisplayString(item.title) + " ", 1),
                      (!item.readAt)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_15, "novo"))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_16, _toDisplayString(item.message), 1),
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.typeLabel(item.type)), 1),
                      (item.createdAt)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(_ctx.formatDateTime(item.createdAt)), 1))
                        : _createCommentVNode("", true)
                    ])
                  ], 8, _hoisted_13)
                ], 2))
              }), 128)),
              (_ctx.loadingMore)
                ? (_openBlock(), _createElementBlock("div", _hoisted_20, "Carregando mais..."))
                : (!_ctx.hasMore)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, "Fim das notificações."))
                  : _createCommentVNode("", true)
            ], 64))
    ], 544)
  ], 2))
}